import Vue from 'vue';
const ActividadesEventBus = new Vue();
export default ActividadesEventBus;
